export const MONTHLY_PRICE_EUR = 20;

import { fetchAdminBypassStatus as apiFetchAdminBypassStatus } from "../services/api";

export function getAuthRedirectUrl() {
  const configuredUrl = import.meta.env.VITE_APP_URL?.trim();
  if (configuredUrl) {
    return configuredUrl.replace(/\/+$/, "");
  }
  return window.location.origin;
}

export function normalizeEmail(value) {
  return value.trim().toLowerCase();
}

export function getPasswordIssues(password) {
  const issues = [];
  const pw = String(password ?? "");

  if (pw.length < 10) {
    issues.push("mindestens 10 Zeichen");
  }
  if (!/[a-z]/.test(pw)) {
    issues.push("mindestens ein Kleinbuchstabe");
  }
  if (!/[A-Z]/.test(pw)) {
    issues.push("mindestens ein Großbuchstabe");
  }
  if (!/[0-9]/.test(pw)) {
    issues.push("mindestens eine Zahl");
  }

  return issues;
}

export function getAuthErrorMessage(error) {
  const rawMessage = String(error?.message || "").trim();
  const message = rawMessage.toLowerCase();

  if (!rawMessage) {
    return "Authentifizierung fehlgeschlagen. Bitte erneut versuchen.";
  }

  if (
    message.includes("passwortanforderungen fehlen") ||
    message.includes("passwort und passwort-bestätigung") ||
    message.includes("gültige e-mail")
  ) {
    return rawMessage;
  }

  if (message.includes("invalid login credentials")) {
    return "E-Mail oder Passwort ist nicht korrekt.";
  }
  if (message.includes("email not confirmed")) {
    return "Bitte bestätige zuerst deine E-Mail-Adresse.";
  }
  if (message.includes("user already registered")) {
    return "Diese E-Mail ist bereits registriert.";
  }
  if (message.includes("user not found")) {
    return "Kein Konto gefunden. Bitte zuerst registrieren.";
  }
  if (message.includes("email address is invalid")) {
    return "Die eingegebene E-Mail-Adresse ist ungültig.";
  }
  if (message.includes("signups not allowed")) {
    return "Magic-Link ist nur für bestehende Konten aktiv. Für neue Konten bitte 'Konto sicher erstellen' nutzen.";
  }
  if (message.includes("redirect_to is not allowed")) {
    return "Redirect-URL ist in Supabase nicht freigegeben.";
  }
  if (message.includes("password")) {
    return "Das Passwort erfüllt die Anforderungen nicht.";
  }

  return `Authentifizierung fehlgeschlagen: ${rawMessage}`;
}

export function isAlreadyRegisteredError(error) {
  const message = String(error?.message || "").toLowerCase();
  return message.includes("user already registered");
}

export async function fetchAdminBypassStatus() {
  try {
    const { data, error: fetchErr } = await apiFetchAdminBypassStatus();
    if (fetchErr || !data?.success) return false;
    return Boolean(data.bypass);
  } catch {
    return false;
  }
}
